import { render, staticRenderFns } from "./Broker.vue?vue&type=template&id=9c2bf3d0&scoped=true&"
import script from "./Broker.vue?vue&type=script&lang=ts&"
export * from "./Broker.vue?vue&type=script&lang=ts&"
import style0 from "./Broker.vue?vue&type=style&index=0&id=9c2bf3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2bf3d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VLayout,VRow})
